import { NgClass, NgIf } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { DsModalTheme } from '@design-system/ds-base-modal/types/ds-modal-theme.type';
import { BaseModalSettingsInterface } from '@interfaces/base-modal-settings.interface';
import { DsButtonComponent } from '@design-system/ds-button/component/ds-button.component';
import { DsBaseModalIconPipe } from '@design-system/ds-base-modal/pipes/ds-base-modal-icon.pipe';

@Component({
  selector: 'ds-confirmation-modal',
  standalone: true,
  imports: [NgIf, NgClass, MatIconModule, DsButtonComponent, DsBaseModalIconPipe],
  templateUrl: './ds-confirmation-modal.component.html',
  styleUrls: ['./ds-confirmation-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DsConfirmationModalComponent {
  private readonly dialogRef = inject(MatDialogRef<DsConfirmationModalComponent, boolean>);
  private readonly dialogData = inject<BaseModalSettingsInterface>(MAT_DIALOG_DATA);

  theme: DsModalTheme = 'success';

  modalSettings: BaseModalSettingsInterface = this.dialogData ?? {};

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirm(): void {
    this.dialogRef.close(true);
  }
}
